(function () {
  var SEL =
    'cart-notification .drawer-bottom button[name="checkout"],' +
    '#minicart-form .drawer-bottom button[name="checkout"],' +
    '.header__minicart .drawer-bottom button[name="checkout"],' +
    '.ocu-cart-drawer .ocu-checkout-button,' +
    'button.ocu-checkout-button';

  function styleButtons(root) {
    var desktop = window.matchMedia('(min-width: 1025px)').matches;
    var minH = desktop ? '72px' : '64px';
    var font = desktop ? '24px' : '22px';
    var pad = desktop ? '22px 28px' : '18px 24px';
    (root || document).querySelectorAll(SEL).forEach(function (btn) {
      btn.style.setProperty('display', 'flex', 'important');
      btn.style.setProperty('align-items', 'center', 'important');
      btn.style.setProperty('justify-content', 'center', 'important');
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('min-height', minH, 'important');
      btn.style.setProperty('padding', pad, 'important');
      btn.style.setProperty('font-size', font, 'important');
      btn.style.setProperty('font-weight', '700', 'important');
      btn.style.setProperty('line-height', '1.15', 'important');
      btn.style.setProperty('box-shadow', '0 6px 24px rgba(17,17,17,0.28)', 'important');
      btn.style.setProperty('visibility', 'visible', 'important');
    });
    (root || document).querySelectorAll('.ocu-checkout-button-text').forEach(function (el) {
      el.style.setProperty('font-size', 'inherit', 'important');
      el.style.setProperty('font-weight', 'inherit', 'important');
    });
  }

  function refreshMinicartForm() {
    var el = document.getElementById('minicart-form');
    if (!el) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=minicart-form')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data['minicart-form'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('#minicart-form');
        if (inner) el.innerHTML = inner.innerHTML;
        styleButtons();
      })
      .catch(function () {
        styleButtons();
      });
  }

  window.teavityStyleMinicartCheckout = styleButtons;
  window.teavityRefreshMinicartForm = refreshMinicartForm;

  styleButtons();

  document.addEventListener('DOMContentLoaded', function () {
    styleButtons();
  });

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('.minicart__action, .header__minicart .header-icon')) {
        refreshMinicartForm().then(function () {
          styleButtons();
        });
      }
    },
    true
  );

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'childList') styleButtons(m.target);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
